{
  "datatable": {
    "rowsPerPage": "Рядків на сторінці"
  },
  "department": {
    "addDepartment": "Додати Департамент",
    "confirms": {
      "deleteText": "Усі користувачі, процедури, навчальні об'єкти, дослідження та пристрої цього департаменту будуть перенесені до департаменту, який ви оберете нижче. Це неможливо скасувати.",
      "deleteTitle": "Видалити {name}?",
      "restoreText": "Це знову зробить департамент видимим та відновить доступ для його персоналу.",
      "restoreTitle": "Відновити {name}?"
    },
    "createNewDepartment": "Створити новий департамент",
    "deletedDepartment": "Департамент видалено",
    "deleteDepartment": "Видалити департамент",
    "departmentAdmin": "Адміністратор Департаменту",
    "departmentName": "Назва Департаменту",
    "institution": "Назва Закладу",
    "institutionName": "Назва Закладу",
    "noReassignmentTarget": "Це єдиний департамент у закладі. Створіть інший департамент перед видаленням цього.",
    "reassignTo": "Перенести до департаменту",
    "restore": "Відновити",
    "restoredDepartment": "Департамент відновлено",
    "searchDepartments": "Пошук департаменту",
    "showArchived": "Показати архівні департаменти",
    "thisFieldIsRequired": "Обов'язкове Поле"
  },
  "general": {
    "accessDenied": "Немає Доступу",
    "add": "Додати",
    "back": "Назад",
    "cancel": "Скасувати",
    "close": "Закрити",
    "dateAdded": "Додано",
    "dateUpdated": "Оновлено",
    "delete": "Видалити",
    "edit": "Редагувати",
    "loading": "Завантаження ...",
    "no": "Ні",
    "noData": "Немає Данных",
    "ok": "ОК",
    "remove": "Видалити",
    "save": "Зберегти",
    "selectAll": "Обрати Все",
    "yes": "Так",
    "selectGender": "Вибрати стать",
    "gender": {
      "male": "Чоловічий",
      "female": "Жіночий"
    },
    "action": "Дія",
    "created": "Створено",
    "updated": "Оновлено",
    "deleted": "Видалено",
    "enabled": "Увімкнено",
    "noHistory": "Історія відсутня"
  },
  "institution": {
    "accessRevoked": "Ваш заклад було видалено. Вас вийшли з системи.",
    "confirms": {
      "deleteText": "Це приховає заклад та його відділення з панелі адміністратора та негайно скасує доступ для всього персоналу. Це можна скасувати, відновивши заклад.",
      "deleteTitle": "Видалити {name}?",
      "restoreText": "Це знову зробить заклад та його відділення видимими та відновить доступ для персоналу.",
      "restoreTitle": "Відновити {name}?"
    },
    "contact": "Контакт",
    "createNewInstitution": "Створити новий заклад",
    "deletedInstitution": "Заклад видалено",
    "deleteInstitution": "Видалити заклад",
    "name": "Ім'я",
    "region": "Регіон",
    "restore": "Відновити",
    "restoredInstitution": "Заклад відновлено",
    "searchInstitutions": "Пошук закладів",
    "showArchived": "Показати архівні заклади",
    "switch": "Змінити",
    "switchedTo": "Заклад змінено на",
    "unableToSwitch": "Неможливо змінити"
  },
  "menu": {
    "categories": "Категорії",
    "departments": "Департамент",
    "home": "Головна",
    "institutions": "Заклади",
    "procedure": "Процедура",
    "procedures": "Процедури",
    "manageProcedures": "Керування процедурами",
    "manageCategories": "Керування категоріями",
    "scheduling": "Розклад",
    "users": "Користувачі"
  },
  "device": {
    "udi": "UDI"
  },
  "procedure": {
    "allSteps": "Всі Кроки",
    "authors": "Автор(и)",
    "category": "Категорія",
    "createNewStep": "Створити Новий Крок",
    "defineFeedback": "Дати Відгук",
    "description": "Опис",
    "disableProcedure": "Вимкнути Процедуру",
    "addProceduresInformation": "Додати Інформацію про процедуру",
    "editProceduresInformation": "Редагувати Інформацію про процедуру",
    "duplicateStartEndStepWarning": "Допускається лише 1 початковий та 1 кінцевий крок",
    "information": "Інформація",
    "language": "Мова",
    "languagesAvailable": "Доступні Мови",
    "media": "Медіа",
    "name": "Назва",
    "owner": "Власник",
    "procedureCategory": "Категорія Процедури",
    "procedureLanguage": "Мова Процедури",
    "procedureName": "Назва Процедури",
    "procedureNotFound": "Процедура не знайдена",
    "public": "Загальна",
    "publicPrivate": "Загальні/Закриті",
    "revisionHistory": "Історія Ревізій",
    "searchSteps": "Пошук кроків",
    "seeFeedback": "Побачити Відгук",
    "statistics": "Статистика",
    "step": "Крок",
    "thisFieldIsRequired": "Обов'язкове Поле",
    "unableToLoad": "Виникла проблема під час завантаження процедур",
    "viewAs": "Переглянути Як",
    "checklist": "Контрольний список",
    "status": "Статус",
    "revisionDate": "Дата",
    "revisionUser": "Користувач",
    "revisionChanges": "Зміни",
    "revisionStepAdded": "додано",
    "revisionStepRemoved": "видалено",
    "revisionStepUpdated": "оновлено",
    "revisionStepReordered": "порядок змінено"
  },
  "procedures": {
    "addProcedure": "Додати процедуру",
    "category": "Категорія",
    "deleteProcedure": "Видалити процедуру",
    "department": "Департамент",
    "filter": "Фільтр",
    "private": "Закриті",
    "procedures": "Процедури",
    "public": "Загальні",
    "publicPrivate": "Загальні/Закриті",
    "searchProcedures": "Пошук процедур",
    "sort": "Сортування"
  },
  "step": {
    "addDescription": "Додати Опис",
    "addParentStep": "Додати батьківський крок",
    "chooseParentSep": "Оберіть батьківський крок",
    "chooseStepOption": "Оберіть опцію кроку",
    "chooseTransitionType": "Оберіть тип переходу",
    "chooseType": "Обрати тип",
    "description": "Опис",
    "dropFilesOrClickToUpload": "Перетягніть файли сюда або нажміть Завантажити",
    "editStep": "Редагувати Крок",
    "insertMaxValue": "Введіть МАКС значення",
    "insertMinValue": "Введіть МІН значення",
    "insertOption": "Ввести опцію",
    "option": "Опція",
    "owner": "Власник",
    "parentStep": "Батьківський крок",
    "previousStep": "Попередній крок",
    "saveMedia": "Зберегти Медіафайли",
    "stepMedia": "Медіафайли кроку",
    "transitionToNextStep": "Переход на наступний крок",
    "transitionType": "Тип переходу",
    "type": "Тип",
    "value": "Значення",
    "viewInProcedure": "Переглянути В Процедурі",
    "error": {
      "WONT_REACH_END": "Немає шляху до КІНЦЯ",
      "EXIT_NOT_IN_USE": "Невикористаний вихід",
      "NO_PARENT_SET": "Немає попереднього кроку",
      "PARENT_NOT_EXITS": "Визначений батьківський крок не існує",
      "DUPLICATE_START": "Процедура може мати лише один крок ПОЧАТОК",
      "DUPLICATE_END": "Процедура може мати лише один крок КІНЕЦЬ",
      "NO_START": "У процедурі відсутній крок ПОЧАТОК",
      "NO_END": "У процедурі відсутній крок КІНЕЦЬ",
      "MULTIPLE_CHILDREN_FOR_EXIT": "Вихід використовується більш ніж одним кроком"
    }
  },
  "user": {
    "accountSettings": "Налаштування акаунту",
    "chooseUserRole": "Обрати Роль Користувача",
    "contact": "Контакт",
    "contactInformation": "Контактна інформація",
    "dateOfBirth": "Дата Народження",
    "department": "Департамент",
    "emails": "Емейл Користувача",
    "emailsDescription": "Введіть 1 або більше емейлів, розділених крапкою з комою. Запрошення зареєструватися з обраною користувацькою ролью буде надіслано на емейл.",
    "filter": "Фільтр",
    "gender": "Стать",
    "institution": "Заклад",
    "institutionalAdmin": "Адміністратор Закладу",
    "institutionAndDepartment": "Заклад та Департамент",
    "inviteUsers": "Запросити Користувача",
    "logOut": "Вийти",
    "nurse": "Медсестра",
    "password": "Пароль",
    "patient": "Паціент",
    "resetPassword": "Скинути Пароль",
    "resetRequestSentTo": "Лист з інформацією про новий пароль відправлено на",
    "searchUsers": "Пошук користувача",
    "sendResetPasswordEmailTo": "Відправити листа з інформацією про новий пароль на",
    "sort": "Сортування",
    "subscription": "Підписка",
    "thisFieldIsRequired": "Обов'язкове Поле",
    "user": "Користувач",
    "userDetailsUpdated": "Дані про користувача оновлено",
    "userInformation": "Користувацька інформація",
    "userRole": "Роль Користувача"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  },
  "patients": {
    "standingAssignment": "Постійне призначення",
    "noStandingAssignment": "Немає постійного призначення",
    "unknownNurse": "Призначена медсестра (ім'я недоступне)",
    "standingAssignmentHelperText": "Як постійне призначення можна обрати лише користувачів із роллю «Home Nurse».",
    "changeStandingAssignment": "Змінити призначення",
    "clearStandingAssignment": "Скасувати призначення",
    "confirmClearStandingAssignmentText": "Ви дійсно бажаєте скасувати постійне призначення для цього пацієнта?",
    "standingAssignmentLabel": "{name} (постійне)",
    "onShiftLabel": "{name} (на зміні)",
    "currentlyOnShiftWith": "Наразі на зміні з",
    "notCurrentlyOnShift": "Наразі не на зміні",
    "visitName": "Назва",
    "visitDate": "Дата",
    "performedBy": "Виконав(ла)",
    "status": "Статус",
    "location": "Розташування / палата (необов'язково)",
    "enterLocation": "Введіть розташування або номер палати",
    "admissionDate": "Дата госпіталізації (необов'язково)",
    "dischargeDate": "Дата виписки (необов'язково)",
    "acuity": "Ступінь тяжкості (необов'язково)",
    "unsupportedFieldsNotice": "Алергія, медикаменти, зріст, вага, тип пацієнта та код/назва стану не підтримуються цим імпортом — додайте їх вручну після імпорту.",
    "import": {
      "importSucceeded": "Імпортовано пацієнтів: {created}, пропущено дублікатів: {duplicates}.",
      "departmentsLoadFailed": "Не вдалося завантажити відділення. Будь ласка, спробуйте ще раз."
    }
  },
  "errors": {
    "UNKNOWN_ERROR": "Невідома помилка"
  },
  "titles": {
    "categories": "Категорії",
    "visitreport": "Звіт про візит"
  },
  "toasts": {
    "patientAdded": "Пацієнта успішно додано",
    "patientUpdated": "Дані пацієнта успішно оновлено",
    "procedureAdded": "Процедуру успішно додано",
    "procedureUpdated": "Процедуру успішно оновлено",
    "procedureDeleted": "Процедуру успішно видалено",
    "visitAdded": "Візит успішно додано",
    "visitUpdated": "Візит успішно оновлено",
    "visitDeleted": "Візит успішно видалено"
  },
  "studyResults": {
    "user": "Користувач",
    "department": "Відділ",
    "study": "Дослідження",
    "date": "Дата",
    "survey": "Опитування",
    "results": "Результати",
    "studyResults": "Результати дослідження",
    "surveyResults": "Результати опитування",
    "list": "Список",
    "graph": "Графік",
    "surveyStartDate": "Початок опитування",
    "surveyEndDate": "Завершення опитування",
    "userResults": "Результати користувача",
    "question": "Питання",
    "questionType": "Тип питання",
    "answer": "Відповідь",
    "position": "Позиція",
    "scaleAnswerFormat": "{value} — {meaning}"
  },
  "visitReport": {
    "consent": "Згода",
    "viewConsent": "Переглянути згоду",
    "homeVisit": "Візит додому",
    "recomendationForTreatment": "Рекомендації щодо лікування, догляду, праці та амбулаторного нагляду",
    "anamnesis": "Анамнез",
    "answerType": "Тип відповіді",
    "contactPhone": "Контактний телефон",
    "contactEmail": "Контактна електронна пошта",
    "visitMadeBy": "Візит здійснив(ла)",
    "homeVisitTime": "Час візиту додому",
    "visitForm": "Форма візиту",
    "viewHistory": "Переглянути історію",
    "patientsPrimaryHealthConcern": "Основна проблема здоров'я пацієнта",
    "conditionAssesmentInformation": "Інформація щодо оцінки стану",
    "bloodPressure": "Артеріальний тиск",
    "measurement": "Вимірювання",
    "BMI": "ІМТ",
    "diagnosis": "Діагноз",
    "appliedMedicalTreatments": "Застосоване медикаментозне лікування",
    "appliedTreatment": "Застосоване лікування",
    "descriptionOfTestsConsultationPlans": "Опис аналізів/планів консультацій",
    "instrumentalTests": "Інструментальні дослідження",
    "laboratoryTests": "Лабораторні дослідження",
    "appliedMedicalTreatment": "Застосоване медичне лікування",
    "specialist": "Спеціаліст",
    "status": "Статус",
    "complaintData": "Дані скарги",
    "pulse": "Пульс",
    "viewFullVisitForm": "Переглянути повну форму візиту",
    "height": "Зріст",
    "weight": "Вага"
  },
  "category": {
    "addCategory": "Додати категорію",
    "confirms": {
      "deleteTitle": "Видалити {name}?",
      "deleteTextImmediate": "У цій категорії немає процедур, її можна видалити негайно. Цю дію неможливо скасувати.",
      "chooseReassignMode": "У цій категорії ще є процедури. Виберіть, як перепризначити їх перед видаленням.",
      "deleteTextAllAtOnce": "Виберіть категорію, до якої буде перенесено всі процедури. Цю дію неможливо скасувати.",
      "deleteTextOneByOne": "Перегляньте процедури нижче, а потім виберіть категорію, до якої їх усі буде перенесено.",
      "affectedProcedures": "Процедури, які буде перенесено",
      "stillHasProcedures": "До цієї категорії ще прив'язані процедури. Будь ласка, виберіть цільову категорію."
    },
    "deletedCategory": "Категорію видалено",
    "editCategory": "Редагувати категорію",
    "frequency": "Частота",
    "reassignAllAtOnce": "Перепризначити всі процедури одразу",
    "reassignOneByOne": "Перепризначити по одній",
    "reassignTo": "Перепризначити на",
    "searchCategories": "Пошук категорій",
    "updatedCategory": "Категорію оновлено"
  }
}
